export const aspectRatioToPadding = (
  aspectRatio: string | string[]
): string | string[] => {
  if (Array.isArray(aspectRatio)) {
    return aspectRatio.map(w => aspectRatioToPadding(w as string)) as string[];
  }

  const [a, b] = aspectRatio.split(":").map(v => parseInt(v, 10));
  return `${100 / (a / b)}%`;
};

// export const aspectRatioToPadding = (aspectRatio: string): string => {
//   const [a, b] = aspectRatio.split(":").map(v => parseInt(v));
//   return `${100 / (a / b)}%`;
// };
